<template>
  <div class="numbered-bullet">
    <div class="circle" :class="variant">
      <span class="number">{{number}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NumberedBullet',
  props: {
    number: Number,
    variant: {
      type: String,
      default: 'blue',
      validator: val => ['blue', 'yellow'].includes(val),
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/riseup-colors';

  .numbered-bullet{
    .circle {
      display: flex;
      justify-content: center;
      height: 32px;
      width: 32px;
      border-radius: 50%;
      font-size: 18px;
      line-height: 24px;
      padding: 5px;
      font-weight: bold;
    }
    .blue {
      background-color: $riseup_light_blue;
      .number {
        color: $riseup_blue
      }
    }
    .yellow {
      background-color: $riseup_yellow;
      .number {
        color: $riseup_orange;
      }
    }

  }
</style>
